/**
 * How long something took, or has waited, in words — Reports → Managers keeping up
 * (Reports step 3, 12/10/2026). The server sends hours as numbers (so the download can
 * sort and sum them); the page says "1 day 4 hours".
 *
 *   0.2  -> "12 minutes"        5.6 -> "6 hours"        28 -> "1 day 4 hours"
 *   48   -> "2 days"            200 -> "8 days"  (a week or more: whole days only)
 */
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

export function formatDuration(hours) {
  if (hours === null || hours === undefined || Number.isNaN(Number(hours))) return '–';
  const h = Math.max(0, Number(hours));
  if (h < 1) {
    const m = Math.max(1, Math.round(h * 60));
    return m >= 60 ? '1 hour' : plural(m, 'minute', 'minutes');
  }
  if (h < 23.5) return plural(Math.round(h), 'hour', 'hours');
  let days = Math.floor(h / 24);
  let rest = Math.round(h - days * 24);
  if (rest === 24) { days += 1; rest = 0; }
  if (days >= 7 || rest === 0) return plural(days, 'day', 'days');
  return `${plural(days, 'day', 'days')} ${plural(rest, 'hour', 'hours')}`;
}

/** "37 days" for the waiting column — whole days once it's past a day, hours before. */
export function formatWaiting(hours) {
  if (hours === null || hours === undefined) return '–';
  const h = Number(hours);
  if (h < 24) return formatDuration(h);
  return plural(Math.floor(h / 24), 'day', 'days');
}

/** "1 of 2 · Approver" */
export function stepLabel(step) {
  if (!step) return 'No steps';
  return `${step.n} of ${step.of}${step.name ? ` · ${step.name}` : ''}`;
}
